"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _customProps = require("../../utils/customProps");

var _customComponents = require("../../utils/customComponents");

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var _MuiListItem = _interopRequireDefault(require("./components/MuiListItem/MuiListItem"));

var _MuiListItemButton = _interopRequireDefault(require("./components/MuiListItemButton/MuiListItemButton"));

/* eslint-disable max-len */
var MuiList = function MuiList(_ref) {
  var rootClass = _ref.rootClass,
      dense = _ref.dense,
      disablePadding = _ref.disablePadding,
      width = _ref.width,
      content = _ref.content;
  var components = {
    MuiListItem: _MuiListItem.default,
    MuiListItemButton: _MuiListItemButton.default
  };

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  return /*#__PURE__*/_react.default.createElement(_List.default, {
    className: styles.root,
    dense: dense,
    disablePadding: disablePadding,
    width: width
  }, content.map(function (component, key) {
    return (0, _customComponents.renderComponents)(components, component, key);
  }));
};

var _default = MuiList;
exports.default = _default;
MuiList.propTypes = {
  /**
   * stroyblok multiselect of css classes
   * Override or extend the styles applied to the component
   * */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /** mui prop: true | false */
  disablePadding: _propTypes.default.bool,

  /**
   * mui prop: true | false
   * If true, compact vertical padding designed for keyboard and mouse input will be used for the list and list items. The prop is available to descendant components as the dense context.
   * */
  dense: _propTypes.default.bool,

  /** width of list */
  width: _propTypes.default.string,

  /** MuiListItem */
  content: function content(props, propName, componentName) {
    var components = ['MuiListItem', 'MuiListItemButton'];
    return (0, _customProps.validComponents)(props, propName, componentName, components);
  }
};
MuiList.defaultProps = {
  width: '100%',
  dense: false,
  disablePadding: false,
  rootClass: [],
  content: []
};